import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/outlet/staff/add')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/_app/outlet/staff/add"!</div>
}
